export type Purchase = { name: string; location: string; time: string };

export const purchases: Purchase[] = [
  { name: "Lucía M.", location: "Córdoba, Argentina", time: "2 minutes ago" },
  { name: "Jessica R.", location: "Austin, United States", time: "4 minutes ago" },
  { name: "Camila G.", location: "Madrid, Spain", time: "7 minutes ago" },
  { name: "Olivia B.", location: "Toronto, Canada", time: "9 minutes ago" },
  { name: "Chloe W.", location: "London, United Kingdom", time: "12 minutes ago" },
  { name: "Valentina P.", location: "Mexico City, Mexico", time: "15 minutes ago" },
  { name: "Mia T.", location: "Sydney, Australia", time: "18 minutes ago" },
  { name: "Sofía L.", location: "Buenos Aires, Argentina", time: "21 minutes ago" },
  { name: "Amanda K.", location: "Miami, United States", time: "25 minutes ago" },
];
